module.exports = __webpack_public_path__ + "img/live.38797768.png";